export function getFullWidthOfDropdown(options) {
    const widths = options.map(x => measureWidth(x.name));
    const longest = Math.max(...widths);
    const arrowWidth = 18;
    const padding = 5;
    const iconWidth = 90;
    return `${longest + arrowWidth + padding + iconWidth}px`;
}

function measureWidth(text) {
    const fontStyle = "normal";
    const fontWeight = "14px";
    const fontFamily = '"Open Sans", Arial, "Helvetica Neue", Helvetica, sans-serif';

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    ctx.font = `${fontStyle} ${fontWeight} ${fontFamily}`;
    const textMetrics = ctx.measureText(text);
    return textMetrics.width;
}
